// extracted by mini-css-extract-plugin
export default {"wrapper":"cx_dt","container":"cx_g","dot":"cx_hh","isActive":"cx_hd"};